import { selectors } from 'data'
import { connect, ConnectedProps } from 'react-redux'

import BackupCodes from './BackupCodes'
import QrCode from './QrCode'

export type PropsType = ConnectedProps<typeof connector>

const mapStateToProps = (state) => ({
  email: selectors.auth.getEmail(state),
  tOtpConfig: selectors.auth.getTotpConfig(state)
})

const connector = connect(mapStateToProps)

const SeedQrCode = connector(QrCode)
const SeedBackupCodes = connector(BackupCodes)

export { SeedBackupCodes, SeedQrCode }
